import React, { Component } from 'react'
import { MDBModal, MDBModalHeader, MDBModalBody, MDBBtn, MDBRow, MDBCol } from 'mdbreact'

export default class modalErrores extends Component {
  render() {
    return (
      <div>
        <MDBModal className="py-1" isOpen={this.props.modalErrores}>
          <MDBModalHeader className="colorConviasa white-text" style={{fontWeight: "bold", color:"black", textAlingLast:"center"}}>
            <h5 style={{fontWeight: "bold", color:"black"}}>AVISO</h5>
          </MDBModalHeader>
          <MDBModalBody className="" style={{fontWeight: "bold", textAlingLast:"center", color:"black", padding:"10px", margin:"10px", alignSelf: "center"}}>
            <h5 style={{fontWeight: "bold", color:"black"}}>{this.props.mensajeError}</h5>
          </MDBModalBody>
          <MDBModalBody className="colorConviasa">
            <MDBRow className="modal-error-center">
              <MDBCol xs="12" sm="12" md="12" lg="12" xl="12" className="mt-4 h6" >
                <span style={{color:"black"}}>Cod. error: {this.props.codigoError}</span>
              </MDBCol>
              <MDBCol xs="12" sm="12" md="12" lg="12" xl="12">
                <MDBBtn style={{borderColor: "green", radius:"0px", backgroundColor:"green", color:"snow"}} onClick={this.props.toggleModalError} color="green">Aceptar</MDBBtn>
              </MDBCol>
            </MDBRow>
          </MDBModalBody>
        </MDBModal>
      </div>
    )
  }
}
